import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'tracking-code-vendor-locales' });

export const { find, create, get, patch, reducer, remove } = actions;

export default reducer;
